import * as actionTypes from "../actionTypes";
import { store } from "../store";

export const currentEntity = CurrentEntity => dispatch => {
    dispatch({
        type: actionTypes.CURRENTENTITY,
        payload: {
            CurrentEntity,
        },
    });
};

export const treeMenuWidth = TreeMenuWidth => dispatch => {
    dispatch({
        type: actionTypes.TREEMENUWIDTH,
        payload: {
            TreeMenuWidth,
        },
    });
};

export const settingsMenuWidth = SettingsMenuWidth => dispatch => {
    dispatch({
        type: actionTypes.SETTINGSMENUWIDTH,
        payload: {
            SettingsMenuWidth,
        },
    });
};

export const updateEntityTree = () => dispatch => {
    dispatch({
        type: actionTypes.UPDATEENTITYTREE,
    });
};

export const updateSpecificNodeEntityTree = nodeToRefreshID => dispatch => {
    dispatch({
        type: actionTypes.UPDATESPECIFICNODE,
        payload: {
            nodeToRefreshID,
        },
    });
};

export const refreshGlobalSearchBar = () => dispatch => {
    dispatch({
        type: actionTypes.REFRESH_GLOBALSEARCHBAR,
        payload: { timestamp: Date.now() }
    });
};

export const updateQuickSearchFilter = QuickSearchFilter => dispatch => {
    dispatch({
        type: actionTypes.QUICKSEARCHFILTER,
        payload: {
            QuickSearchFilter,
        },
    });
};

export const updateSearchCategoriesImmediate = SearchCategoriesImmediate => dispatch => {
    dispatch({
        type: actionTypes.SEARCHCATEGORIES_IMMEDIATE,
        payload: { SearchCategoriesImmediate }
    });
};

export const updateMaxResultCount = MaxResultCount => dispatch => {
    dispatch({
        type: actionTypes.MAXRESULTCOUNT,
        payload: {
            MaxResultCount,
        },
    });
};

export const updateQuickSearch = quickSearch => dispatch => {
    dispatch({
        type: actionTypes.QUICKSEARCH,
        payload: quickSearch,
    });
};

/** Programatically expand the treeview until the reach of the given node (via the nodeID's suite) DOC*/
export const updateTreeViewNodeExpand = TreeViewNodeExpand => dispatch => {
    dispatch({
        type: actionTypes.TREEVIEWNODEEXPAND,
        payload: {
            TreeViewNodeExpand,
        },
    });
};

export const updateDifferentEntitySelected = DifferentEntitySelected => dispatch => {
    dispatch({
        type: actionTypes.DIFFERENTENTITYSELECTED,
        payload: {
            DifferentEntitySelected,
        },
    });
};

export const updateHighlightedRows = VisitedRow => dispatch => {
    dispatch({
        type: actionTypes.UPDATEHIGHLIGHTEDROWS,
        payload: {
            [VisitedRow.CurrentLocation]: VisitedRow.VisitedRowID,
        },
    });
};

/** Bookmark actions for child nodes of the tree menu : add and remove (we'll check the route as the id) */
export const menuBookmarked = TreeNode => dispatch => {
    const token = store.getState().auth.Token;
    dispatch({
        type: actionTypes.MENUBOOKMARKED,
        payload: { TreeNode, token },
    });
};
export const menuUnbookmarked = TreeNode => dispatch => {
    const token = store.getState().auth.Token;
    dispatch({
        type: actionTypes.MENUUNBOOKMARKED,
        payload: { TreeNode, token },
    });
};

export const mapPref = (map, mapState) => async dispatch => {
    const token = store.getState().auth.Token;
    dispatch({
        type: actionTypes.MAPPREF,
        payload: {
            map,
            mapState,
            token,
        },
    });
};
export const initializePref = (MapPrefs, BookmarkPrefs) => dispatch => {
    dispatch({
        type: actionTypes.INITIALIZEPREFS,
        payload: {
            MapPrefs,
            BookmarkPrefs,
        },
    });
};

export const isFetching = status => dispatch => {
    dispatch({
        type: actionTypes.ISFETCHING,
        payload: status,
    });
};

export const nextRoute = (nextFollowedUserRoute) => dispatch => {
    dispatch({
        type: actionTypes.NEXTFOLLOWEDUSERROUTE,
        payload: nextFollowedUserRoute
        ,
    })
};

export const resetNotifCount = () => dispatch => {
    dispatch({
        type: actionTypes.NEWNOTIFCOUNT,
        payload: { Value: 0 },
    });
};

export const updateEddDataValidationProgress = (progress) => dispatch => {
    dispatch({
        type: actionTypes.UPDATEDATAVALIDATIONPROGRESS,
        payload: { Progress: progress}
    })
};

export const updateSheetName = (sheetName) => dispatch => {
    dispatch({
        type: actionTypes.UPDATESHEETNAME,
        payload: { SheetName: sheetName}
    })
};

export const updateBranchCountryTree = () => dispatch => {
    dispatch({
        type: actionTypes.UPDATEBRANCHESANDCOUNTRIES,
        payload: { timestamp: Date.now() }
    });
};

export const refreshRecycleBinGrid = () => dispatch => {
    dispatch({
        type: actionTypes.REFRESHRECYCLEBINGRID,
        payload: { timestamp: Date.now() }
    });
};

export const setShowAdvancedSearchCriterias = ShowAdvancedSearchCriterias => dispatch => {
    dispatch({
        type: actionTypes.SHOW_ADVANCED_SEARCH_CRITERIAS,
        payload: { ShowAdvancedSearchCriterias }
    });
};

export const updateEntitiesResults = results => dispatch => {
    dispatch({
        type: actionTypes.UPDATE_ENTITIES_RESULTS,
        payload: { results }
    });
};

export const updateDocumentsResults = results => dispatch => {
    dispatch({
        type: actionTypes.UPDATE_DOCUMENTS_RESULTS,
        payload: { results }
    });
};

export const updateStationsResults = results => dispatch => {
    dispatch({
        type: actionTypes.UPDATE_STATIONS_RESULTS,
        payload: { results }
    });
};

export const updateZonesResults = results => dispatch => {
    dispatch({
        type: actionTypes.UPDATE_ZONES_RESULTS,
        payload: { results }
    });
};

export const updateSamplingsResults = results => dispatch => {
    dispatch({
        type: actionTypes.UPDATE_SAMPLINGS_RESULTS,
        payload: { results }
    });
};

export const clearSearchResults = () => dispatch => {
    dispatch({
        type: actionTypes.CLEAR_SEARCH_RESULTS
    });
};

export const updateFilters = () => dispatch => {
    dispatch({
        type: actionTypes.FILTER_CRITERIAS_UPDATED,
        payload: { timestamp: Date.now() }
    });
};